__turbopack_context__.v({
  "albumContainerDesktop": "staticChannelCard-module-scss-module__Yxt3qq__albumContainerDesktop",
  "albumImage": "staticChannelCard-module-scss-module__Yxt3qq__albumImage",
  "albumWrapper": "staticChannelCard-module-scss-module__Yxt3qq__albumWrapper",
  "borderBackground": "staticChannelCard-module-scss-module__Yxt3qq__borderBackground",
  "button": "staticChannelCard-module-scss-module__Yxt3qq__button",
  "channelCard": "staticChannelCard-module-scss-module__Yxt3qq__channelCard",
  "colorBorder": "staticChannelCard-module-scss-module__Yxt3qq__colorBorder",
  "contentWrapper": "staticChannelCard-module-scss-module__Yxt3qq__contentWrapper",
  "desktopColorBorder": "staticChannelCard-module-scss-module__Yxt3qq__desktopColorBorder",
  "disableShadow": "staticChannelCard-module-scss-module__Yxt3qq__disableShadow",
  "listenLiveText": "staticChannelCard-module-scss-module__Yxt3qq__listenLiveText",
  "playIcon": "staticChannelCard-module-scss-module__Yxt3qq__playIcon",
  "radioImage": "staticChannelCard-module-scss-module__Yxt3qq__radioImage",
  "radioImageLink": "staticChannelCard-module-scss-module__Yxt3qq__radioImageLink",
  "radioInfoContainer": "staticChannelCard-module-scss-module__Yxt3qq__radioInfoContainer",
  "radioTextInfo": "staticChannelCard-module-scss-module__Yxt3qq__radioTextInfo",
  "shadow": "staticChannelCard-module-scss-module__Yxt3qq__shadow",
  "staticDisplay": "staticChannelCard-module-scss-module__Yxt3qq__staticDisplay",
});
